import "./assets/main.scss";

import { createApp } from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import App from "./App.vue";
import router, { bindAppToRouter } from "./router";
import store from "./store";

import { bindInterceptors } from "./services/http-client";
import { authService } from "./services/auth";
import { createI18n } from "vue-i18n";
import messages from "./locales/es.json";

let vm;
let siteKey;
const i18n = createI18n({
  locale: 'es',
  fallbackLocale: 'es',
  legacy: false,
  messages
});
(async () => {
  const siteKeyPromise = authService.getReCaptchaV3SiteKey();
  const app = createApp(App).use(store).use(router).use(i18n);

  try {
    siteKey = await siteKeyPromise;
    app.use(VueReCaptcha, { siteKey, loaderOptions: { autoHideBadge: true } });
  } catch (error) {
    console.warn("Could not fetch recaptcha site key. Auth might fail.");
  }

  vm = app.mount("#app");

  bindInterceptors(vm);
  bindAppToRouter(vm);
})();

export { vm };
